import { useEffect, useMemo } from "react";
import {
  getCarrito,
  updateItemConfig,
  addItem,
} from "./carritoService";

/* ===============================
   HOOK
================================ */
export function useCarritoProducto({
  producto,
  cantidad,
  setCantidad,
  nota,
  setNota,
  base,
  setBase,
  esJugo,
  personalizarCadaUno,
  extrasSeleccionados,
  extrasBD,
  configPorUnidad,
  navigate,
}) {
  /* ===============================
     EDICIÓN
  ================================ */
  const editInfo = useMemo(() => {
    try {
      return JSON.parse(
        localStorage.getItem("linea_editando") || "null"
      );
    } catch {
      return null;
    }
  }, []);

  const lineIdEditando = editInfo?.lineId || null;

  /* ===============================
     PRECARGA SI EDITA
  ================================ */
  useEffect(() => {
    if (!lineIdEditando) return;

    const carrito = getCarrito();
    const linea = carrito.items.find(
      (i) => i.lineId === lineIdEditando
    );

    if (!linea) return;

    setCantidad(linea.cantidad || 1);
    setNota(linea.nota || "");
    setBase(linea.config?.base || "");
  }, [lineIdEditando, setCantidad, setNota, setBase]);

  /* ===============================
     FLAGS
  ================================ */
  const puedeAgregar =
    producto && (!esJugo || base !== "" || personalizarCadaUno);

  const labelPrincipal = lineIdEditando
    ? "Guardar cambios"
    : "Agregar al carrito";

  /* ===============================
     ACCIÓN PRINCIPAL
  ================================ */
  const agregarCarrito = () => {
    if (!producto) return;

    /* --------- EDICIÓN --------- */
    if (lineIdEditando) {
      if (personalizarCadaUno) {
        alert(
          "Para editar un producto, desactiva 'Personalizar cada uno'."
        );
        return;
      }

      if (esJugo && base === "") {
        alert("Debes elegir Agua o Leche");
        return;
      }

      updateItemConfig(lineIdEditando, {
        precioBase: Number(producto.precio || 0),
        cantidad,
        nota,
        config: {
          base,
          extras: extrasSeleccionados.map((e) => ({
            id: e.id,
            name: e.nombre,
            price: e.precio,
            qty: e.qty,
          })),
        },
      });

      localStorage.removeItem("linea_editando");
      navigate("/pedido/carrito");
      return;
    }

    /* --------- CREAR (MODO NORMAL) --------- */
    if (!personalizarCadaUno) {
      if (esJugo && base === "") {
        alert("Debes elegir Agua o Leche");
        return;
      }

      addItem({
        id: producto.id,
        nombre: producto.nombre,
        categoria: producto.categoria,
        precioBase: Number(producto.precio || 0),
        base,
        extras: extrasSeleccionados.map((e) => ({
          id: e.id,
          name: e.nombre,
          price: e.precio,
          qty: e.qty,
        })),
        nota,
        cantidad,
      });

      navigate("/pedido");
      return;
    }

    /* --------- CREAR (POR UNIDAD) --------- */
    if (esJugo) {
      const falta = configPorUnidad.some((u) => !u.base);
      if (falta) {
        alert(
          "En 'Personalizar cada uno', cada jugo debe tener Agua o Leche."
        );
        return;
      }
    }

    configPorUnidad.forEach((u) => {
      const extrasUnidad = extrasBD
        .map((e) => ({
          id: e.id,
          name: e.nombre,
          price: Number(e.precio || 0),
          qty: (u.extrasQty || {})[e.id] || 0,
        }))
        .filter((x) => x.qty > 0);

      addItem({
        id: producto.id,
        nombre: producto.nombre,
        categoria: producto.categoria,
        precioBase: Number(producto.precio || 0),
        base: esJugo ? u.base : "",
        extras: extrasUnidad,
        nota: u.nota || "",
        cantidad: 1,
      });
    });

    navigate("/pedido");
  };

  /* ===============================
     RETURN
  ================================ */
  return {
    lineIdEditando,
    puedeAgregar,
    labelPrincipal,
    agregarCarrito,
  };
}
